const path = require('path');

/**
 * These is rendered in gatsby-node.js
 * and used in links
 */

const primaryMenuRoutes = [
  {
    name: 'Produkt',
    path: 0,
    component: path.resolve(__dirname, 'templates/produkt.tsx'),
    settingType: 'allSiteSettingEntityProduct',
  },
  {
    name: 'Cennik',
    path: 1,
    component: path.resolve(__dirname, 'templates/cennik.tsx'),
    settingType: 'allSiteSettingEntityPriceList',
  },
  {
    name: 'Kasa fiskalna vs kasoterminal',
    nameHTML: 'Kasa fiskalna <sup>vs</sup> kasoterminal',
    path: 2,
    component: path.resolve(__dirname, 'templates/kasa-fiskalna-vs-kasoterminal.tsx'),
    settingType: 'allSiteSettingEntityKasaFiskalnaVsKasoterminal',
  },
  {
    name: 'Franczyzy',
    path: 18,
    component: path.resolve(__dirname, 'templates/franczyzy.tsx'),
    settingType: 'allSiteSettingEntityFranchise',
  },
];

const browserOnlyRoutes = [
  {
    name: 'Konfigurator',
    path: 6,
    component: path.resolve(__dirname, 'templates/konfigurator.tsx'),
    context: {
      id: 'krok-2',
      layout: 'configurator',
    },
  },
  {
    name: 'Konfigurator',
    path: 7,
    component: path.resolve(__dirname, 'templates/konfigurator.tsx'),
    context: {
      id: 'krok-3',
      layout: 'configurator',
    },
  },
  {
    name: 'Konfigurator',
    path: 8,
    component: path.resolve(__dirname, 'templates/konfigurator.tsx'),
    context: {
      id: 'krok-4',
      layout: 'configurator',
    },
  },
  {
    name: 'Konfigurator',
    path: 9,
    component: path.resolve(__dirname, 'templates/konfigurator.tsx'),
    context: {
      id: 'colors',
      layout: 'configurator',
    },
  },
  {
    name: 'Konfigurator',
    path: 10,
    component: path.resolve(__dirname, 'templates/konfigurator.tsx'),
    context: {
      id: 'accessories',
      layout: 'configurator',
    },
  },
];

// server-side rendered routes
const ssrRoutes = [
  ...[
    {
      name: 'Homepage',
      path: 20,
      component: path.resolve(__dirname, 'templates/index.tsx'),
      settingType: 'allSiteSettingEntityMainPage',
    },
    {
      name: 'Konfigurator',
      path: 4,
      component: path.resolve(__dirname, 'templates/konfigurator.tsx'),
      context: {
        id: 'krok-1',
        layout: 'configurator',
      },
    },
    {
      name: 'Potwierdzenie zamówienia',
      path: 11,
      component: path.resolve(__dirname, 'templates/konfigurator-potwierdzenie.tsx'),
    },
    {
      name: 'Aktualności',
      path: 15,
      component: path.resolve(__dirname, 'templates/aktualnosci.tsx'),
      settingType: 'allSiteSettingEntityAktualnosci',
    },
    {
      name: 'Demo',
      path: 12,
      component: path.resolve(__dirname, 'templates/demo.tsx'),
      settingType: 'allSiteSettingEntityDemo',
    },
    {
      name: 'Dofinansowanie',
      path: 17,
      component: path.resolve(__dirname, 'templates/dofinansowanie.tsx'),
      settingType: 'allSiteSettingEntityFinancing',
    },
    {
      name: 'Demo potwierdzenie',
      path: 13,
      component: path.resolve(__dirname, 'templates/demo-potwierdzenie.tsx'),
    },
    {
      name: 'O Nas',
      path: 14,
      component: path.resolve(__dirname, 'templates/o-nas.tsx'),
      settingType: 'allSiteSettingEntityAboutUs',
    },
    {
      name: 'Inter Cars',
      path: 19,
      component: path.resolve(__dirname, 'templates/inter-cars.tsx'),
      settingType: 'allSiteSettingEntityIntercars',
    },
    {
      name: 'Akcesoria',
      path: 16,
      component: path.resolve(__dirname, 'templates/akcesoria.tsx'),
      settingType: 'allSiteSettingEntityAccessories',
    },
    {
      name: 'Branże',
      path: 3,
      component: path.resolve(__dirname, 'templates/branze.tsx'),
      settingType: 'allSiteSettingEntityBranches',
    },
  ],
  ...primaryMenuRoutes,
  ...browserOnlyRoutes,
];

const routes = [...ssrRoutes, ...browserOnlyRoutes];

// Same keys as 'routes', but the value is only the path.
const paths = Object.keys(routes).reduce((acc, route) => {
  acc[route] = routes[route].path;
  return acc;
}, {});

module.exports = {
  ssrRoutes,
  browserOnlyRoutes,
  routes,
  primaryMenuRoutes,
  paths,
};
